import { getMenuIdFromUrl } from '../APIs/auth';

/**
 * Builds the exact payload for Memorize action
 */
export const buildMemorizePayload = ({
  menuId,
  transactionView,
  reportType,
  reportTitle,
  selectedFields,
  department,
  departmentName,
  jobTitle,
  jobTitleName,
}) => {
  const finalMenuId = menuId || getMenuIdFromUrl() || '000000000000000000000000000000000000';
  const viewTransType = Number.isInteger(Number(transactionView)) ? Number(transactionView) : 5;
  const reportBy = reportType === 'daily' ? 1 : reportType === 'weekly' ? 2 : reportType === 'monthly' ? 3 : 1;
  const finalTitle = reportTitle || 'Time and Attendance Report';

  // Format department and job title name
  let finalDept = 'all';
  if (departmentName && String(departmentName).toLowerCase() !== 'all') {
    finalDept = String(departmentName).trim();
  } else if (department && String(department).toLowerCase() !== 'all' && department.length !== 36) {
    finalDept = String(department).trim();
  }

  let finalJob = 'all';
  if (jobTitleName && String(jobTitleName).toLowerCase() !== 'all') {
    finalJob = String(jobTitleName).trim();
  } else if (jobTitle && String(jobTitle).toLowerCase() !== 'all' && jobTitle.length !== 36) {
    finalJob = String(jobTitle).trim();
  }

  const deptJobPart = `${finalDept}%${finalJob}`;

  // Format selected green boxes as %field (e.g. %status%otpercent%otrisk)
  const fieldsPart = (selectedFields || []).map((f) => `%${f.toLowerCase()}`).join('');
  const customizeString = `${deptJobPart}${fieldsPart}`;

  return {
    MenuId: String(finalMenuId),
    ViewTransType: Number(viewTransType),
    ReportBy: Number(reportBy),
    ReportTitle: String(finalTitle),
    CustomizeString: String(customizeString),
  };
};


/**
 * Builds the exact payload for Reset action (only MenuId)
 */
export const buildResetPayload = (menuId) => {
  const finalMenuId = menuId || getMenuIdFromUrl() || '000000000000000000000000000000000000';
  return {
    MenuId: finalMenuId,
  };
};
